import React from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonIcon, IonButtons } from '@ionic/react';
import { useHistory } from 'react-router';
import { arrowBack } from 'ionicons/icons';
import { _urls, _dict, _defaultButtonColor } from '../components/constants';
import { useGlobalStore } from '../components/stateManagement/globalZustand';

const ProblemReportPage: React.FC = () => {
    const {lang} = useGlobalStore();
  const history = useHistory();

  const handleNavigation = (url: string) => {
    window.location.href = url;
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{_dict.loginChecklistTitle[lang]}</IonTitle>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon icon={arrowBack} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <div style={{ fontSize: "18px" }}>
          <ol>
            <li>{_dict.loginChecklistItem2[lang]}<br /><br /></li>
            <li>{_dict.loginChecklistItem3[lang]}<br /><br /></li>
          </ol>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "30px" }}>
          <IonButton
            expand="full"
            style={{ "--background": _defaultButtonColor, width: "90%" }}
            onClick={() => handleNavigation(_urls.loginProblemForm[lang])}
          >
            {_dict.reportLoginIssue[lang]}
          </IonButton>
          <IonButton
            expand="full"
            style={{ "--background": _defaultButtonColor, width: "90%", marginTop: "10px" }}
            onClick={() => handleNavigation(_urls.feedbackForm[lang])}
          >
            {_dict.reportOtherIssue[lang]}
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ProblemReportPage;
